module.exports = __webpack_public_path__ + "img/zyzcy-icon.d10f181f.png";